import { useEffect } from "react";
import { useEffectEvent } from "../hooks/useEffectEvent";
import type { PubSub } from "./pubSub";

type AnyFunction = (...args: any[]) => any;

/**
 * Subscribes to a PubSub instance with automatic lifecycle management.
 *
 * - Subscribes on mount, unsubscribes on cleanup
 * - Stabilizes the callback internally — consumer can pass an inline function
 *   without causing re-subscriptions
 */
export const useSubscribe = <T extends AnyFunction>(pubSub: PubSub<T>, callback: T) => {
    const stableCallback = useEffectEvent(callback);

    useEffect(() => {
        const cleanup = pubSub.subscribe(stableCallback as T);
        return cleanup;
    }, [pubSub, stableCallback]);
};
